import es from './es-api';
import co from './cluster-overview';
import uc from '../ui/cluster';
import cd from '../data/cluster-data';

let nodeIndex = {
  addAlias : (name, alias)=>{
    es.post(es.ep.alias.add,JSON.stringify({actions: [{add: {index: name, alias: alias}}]}), data=>{
      alert(JSON.stringify(data));
      co.cluster();
      uc.bindIndices();
    });
  },
  removeAlias : (name, alias)=>{
    es.post(es.ep.alias.add,JSON.stringify({actions: [{remove: {index: name, alias: alias}}]}), data=>{
      alert(JSON.stringify(data));
      co.cluster();
      uc.bindIndices();
    });
  },
  refresh : name=>{
    es.post(es.ep.indices.refresh(name), '', data=>{
      alert(JSON.stringify(data));
    })
  },
  flush : name=>{
    es.post(es.ep.indices.flush(name), '', data=>{
      alert(JSON.stringify(data));
    })
  },
  optimize : (name, param)=>{
    es.post(es.ep.indices.optimize(name), param, data=>{
      alert(JSON.stringify(data));
    })
  },
  gatewaySnapshot: name=>{
    es.post(es.ep.indices.gatewaySnapshot(name), '', data=>{
      alert(JSON.stringify(data));
    })
  },
  analyser: (name, param)=>{
    es.get(es.ep.indices.analyser(name)+"?"+param, data=>{
      alert(JSON.stringify(data));
    })
  },
  state : name=>{
    $.each(cd.cluster.indices, (i,x)=>{
      if(x.name === name){
        if (x.metadata.state === "open"){
          es.post(es.ep.indices.close(name), '', data=>{
            alert(JSON.stringify(data));
            co.cluster();
            uc.bindOverview();
          });
        }else{
          es.post(es.ep.indices.open(name), '', data=>{
            alert(JSON.stringify(data));
            co.cluster();
            uc.bindOverview();
          });
        }
      }
    });
  },
  delete : name=>{
    es.delete(es.ep.indices.delete(name), '', data=>{
      alert(JSON.stringify(data));
      co.cluster();
      uc.bindOverview();
    })
  }
}

export default nodeIndex;


// WEBPACK FOOTER //
// ./src/scripts/data/node-index.js